import {
  FilterMode,
  SignedEditionDndaWorkflowStateCreateMutationVariables,
  SignedEditionDndaWorkflowState_OrderBy,
  SignedEditionDndaWorkflowState,
  SortOrder,
  SignedEditionDndaWorkflowState_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const signedEditionDndaWorkflowStateService = {
  createOne: buildCreateOne(
    (
        signedEditionDndaWorkflowStateCreateVariables: SignedEditionDndaWorkflowStateCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.signedEditionDndaWorkflowStateCreate(
          signedEditionDndaWorkflowStateCreateVariables
        );
        return result.signedEditionDndaWorkflowStateCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.signedEditionDndaWorkflowStateOne({ id });
    return result.signedEditionDndaWorkflowStateOne as SignedEditionDndaWorkflowState;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: SignedEditionDndaWorkflowState_OrderBy[] | null = null,
    filter: SignedEditionDndaWorkflowState_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: SignedEditionDndaWorkflowState_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.signedEditionDndaWorkflowStateListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.signedEditionDndaWorkflowStateListWithOffset
    ) as SignedEditionDndaWorkflowState[];
    return { list, orderBy };
  },
};
